import { create } from "zustand";

export const usePaymentStore = create((set) => ({
        payType: "Basic",
        credits: {
            AT: 0,
            CS: 0,
            IV: 0,
            DE: 0,
        },

        setPaymentData: ({ payType, userCredits }) =>
            set(() => {
            const creditMap = { AT: 0, CS: 0, IV: 0, DE: 0 };

            userCredits.forEach((c) => {
                creditMap[c.type] = c.balance;
            });

            return {
                payType,
                credits: creditMap,
            };
        }),

        deductCredit: (type, amount = 1) =>
            set((state) => ({
            credits: {
                ...state.credits,
                [type]: Math.max(0, state.credits[type] - amount),
            },
        })),
    })
);
